<script setup lang="ts">
import { useRouter } from 'vue-router'
import QuestionsTemplate from '@/components/templates/common/questions/QuestionsTemplate/index.vue'
import QuestionsOneContent from '@/components/organisms/common/questions/QuestionsOneContent/index.vue'
import { useVueInject } from '@/hooks/vue'
import { QuestionsStoreKey, QuestionsStore } from '@/stores/common/questions'
import { useActions } from '.'

const router = useRouter()
const store = useVueInject<QuestionsStore>(QuestionsStoreKey)
const actions = useActions(store, router)
</script>

<template>
  <QuestionsTemplate
    :page-number="1"
    :question-text="'どちらのフォトグラファーから選びますか？'"
    :input-value="store.state.inputs.q1"
  >
    <QuestionsOneContent :selected="store.state.inputs.q1" @input="actions.handleInput" />
  </QuestionsTemplate>
</template>
